import * as React from "react";

function ButtonDownSvg(props) {
  return (
    <svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={48} height={48} rx={24} fill="#F2FFF3" />
      <path
        d="M33.24 20.442l-7.607 7.607a2.317 2.317 0 01-3.267 0l-7.606-7.607"
        stroke="#3E3D3D"
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ButtonDownSvg;
